import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 * */
export default class GetNewsSuggestionsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPAdsRepository} deps.repository
   * @param {Object} deps.log
   * */
  constructor({repository, log}) {
    super({repository, log})

    this._repository = repository
    this._log = log
  }

  /**
   * @param {Object} search
   * @param {String} search.term
   * @return {Promise<Object, Error>} list of suggestions
   * @property {Array<{literal: string, model:number}>} suggestions
   * */
  execute({term}) {
    return new Promise((resolve, reject) => {
      if (!term) {
        return reject(new Error('[GetNewsSuggestionsUseCase#execute] term is empty'))
      }

      resolve(
        this._repository.getNewsSuggestions({term}).then(suggestions => ({
          suggestions: suggestions.map(suggestion => suggestion.toJSON())
        }))
      )
    })
  }
}
